import { render, staticRenderFns } from "./addtohomescreen.vue?vue&type=template&id=826e0086&scoped=true&"
import script from "./addtohomescreen.vue?vue&type=script&lang=js&"
export * from "./addtohomescreen.vue?vue&type=script&lang=js&"
import style0 from "./addtohomescreen.vue?vue&type=style&index=0&id=826e0086&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826e0086",
  null
  
)

export default component.exports